import React, { useCallback, useRef, useState } from 'react';
import ChooseFileIcon from '../../../../../assets/images/chooseFile'
import './DraggableUpload.scss'

const options = {
    DRAGGING: "dragging",
    ERROR: "error",
    ERRORSIZE: "errorSize",
    LOADING: "isLoading",
    DISABLED: "disabled"
}

const allowedTypes = [
    "application/pdf",
    "application/vnd.ms-powerpoint",
    "application/vnd.ms-excel",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    "application/vnd.openxmlformats-officedocument.presentationml.presentation",
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    "application/msword",
]

const handleSetFile = (file, setFile, setStatus) => {
    setTimeout(() => {
        if (file.size > 200 * 1024 * 1024) {
            setStatus(options.ERRORSIZE)
        } else if (!allowedTypes.includes(file.type)) {
            setStatus(options.ERROR)
        } else {
            setFile(file);
            setStatus(null);
        }
    }, 1000);
}

const LoadingSpinner = () => {
    return (
        <>
            <div className="loader"></div>
            <div>Loading file</div>
        </>
    )
}

const DNDContent = ({ setFile, setStatus }) => {
    const inputRef = useRef(null);

    const handleFileChange = useCallback((e) => {
        setStatus(options.LOADING);
        if (e.target.files) {
            const file = e.target.files[0];
            handleSetFile(file, setFile, setStatus);
        }
    }, [setFile]);

    const handleClick = useCallback(() => {
        inputRef.current.click();
    }, [inputRef]);

    return (
        <>
            <p>Drag and drop file here</p>
            <p>or</p>
            <button onClick={handleClick}><ChooseFileIcon /> Choose file</button>
            <p>We accept PDF, PPT, Excel, and Word Files</p>
            <input ref={inputRef} id="file" type="file" onChange={handleFileChange} style={{ display: 'none' }} />
        </>
    )
}

const DraggableUpload = ({ setFile }) => {
    const [status, setStatus] = useState(null);

    const handleDrag = useCallback((e) => {
        e.preventDefault();
        e.stopPropagation();
        if (e.type === "dragenter" || e.type === "dragover") {
            setStatus(options.DRAGGING)
        } else if (e.type === "dragleave" || e.type === "drop") {
            setStatus(null)
        }
    }, []);

    const handleDrop = useCallback((e) => {
        e.preventDefault();
        e.stopPropagation();
        setStatus(options.LOADING);
        if (e.dataTransfer.files && e.dataTransfer.files[0]) {
            const file = e.dataTransfer.files[0];
            handleSetFile(file, setFile, setStatus);
        }

    }, [setFile]);

    return (
        <div>
            <div
                className={`upload-zone ${status ? status : ''}`}
                onDragEnter={handleDrag}
                onDragOver={handleDrag}
                onDragLeave={handleDrag}
                onDrop={handleDrop}
            >
                {
                    status === options.LOADING ?
                        <LoadingSpinner /> : <DNDContent setFile={setFile} setStatus={setStatus} />
                }
            </div>
            {status === options.ERROR && <p className={`upload-zone-size error`}>Just .pdf, .pptx, .xlsx and .docx files are supported.</p>}
            {status !== options.ERROR && <p className={`upload-zone-size ${status === options.ERRORSIZE ? "error" : ''}`}>Maximum upload file size: 200 MB.</p>}
        </div>
    );
};

export default DraggableUpload;